import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useHomepageContent } from '../lib/hooks/useHomepageContent';
import { useSettings } from '../lib/hooks/useSettings';
import { SITE_NAME } from '../lib/brand';

const Hero = () => {
  const { content, loading } = useHomepageContent();
  const { settings } = useSettings();

  if (loading) {
    return (
      <section className="relative h-screen-90">
        <div className="absolute inset-0 bg-gray-200 animate-pulse"></div>
      </section>
    );
  }

  return (
    <section className="relative h-screen-90">
      <div className="absolute inset-0">
        {content.hero.videoUrl ? (
          <video
            src={content.hero.videoUrl}
            poster={content.hero.backgroundImage}
            autoPlay
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        ) : (
          <img
            src={content.hero.backgroundImage}
            alt={settings.companyName || SITE_NAME}
            className="w-full h-full object-cover"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/50" />
      </div>
      
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="container-custom text-center text-white px-4">
          <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto">
            {/* The logo replaces the title when one is uploaded in Settings;
                the title stays as the accessible name and the fallback. */}
            {settings.logoUrl ? (
              <h1 className="mb-6">
                <img
                  src={settings.logoUrl}
                  alt={content.hero.title}
                  className="h-32 md:h-48 w-auto max-w-full mx-auto object-contain drop-shadow-2xl"
                />
              </h1>
            ) : (
              <h1 className="font-sans text-4xl md:text-6xl font-bold mb-6 leading-tight text-white drop-shadow-2xl">
                {content.hero.title}
              </h1>
            )}
            <p className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto text-white/95 drop-shadow-lg">
              {content.hero.subtitle}
          </p>
            <Link
            to="/apartments"
              className="inline-flex items-center space-x-2 bg-primary text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-primary-dark transition duration-300 shadow-2xl hover:shadow-primary/25"
          >
              <span>{content.hero.buttonText}</span>
            <ChevronRight size={20} />
          </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;